import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes'

import { CookiesProvider } from "react-cookie";

import { createRoot } from 'react-dom/client';
const root = createRoot(document.getElementById('root'));
root.render(
  <CookiesProvider>
    <Routes />
  </CookiesProvider>
);

// root.render(
//   <CookiesProvider>
//     <Routes />
//   </CookiesProvider>,
//   document.getElementById('root')
// );

